import * as React from 'react';
import { ColorSwatchWrapper, ColorRowWrapper, ColorPrimaryWrapper, ColorOverlay, CustomHoverText } from './ColorSwatch_SC';
import { XIColors, SnackBar } from '@inmoment/the-kitchen';

type SnackBarProps = Parameters<typeof SnackBar>[0];

interface colorRow {
  hex: string;
  name: string;
  rgb?: string;
  text?: 'orca' | 'white';
}

export interface Props {
  color: string;
  description: string;
  primaryHex: string;
  rows: colorRow[];
}

export const ColorSwatch: React.FC<Props> = (props) => {
  const { color, description, rows, primaryHex } = props;
  const [snackBarObject, setSnackBarObject] = React.useState<SnackBarProps | null>(null);
  const textArea = React.useRef<HTMLTextAreaElement>(null);

  function handleClick(text: string) {
    if (textArea.current) textArea.current.value = text;
    textArea.current?.select();
    document.execCommand('copy');
    setSnackBarObject({
      mode: 'default',
      text: `${text} copied to clipboard`,
      dismissTime: 5000,
      autoDismiss: true,
      id: new Date().getTime().toString(),
    });
  }
  return (
    <ColorSwatchWrapper>
      <div style={{ padding: 18, display: 'flex' }}>
        <ColorPrimaryWrapper
          color={primaryHex}
          style={{
            border: color === 'White' ? `1px solid ${XIColors.grey.light[80]}` : 'none',
          }}
        />
        <div style={{ padding: '0 12px', flex: 1 }}>
          <p className="kxi-text-600 kxi-text-medium">{color}</p>
          <p className="kxi-text-300">{description}</p>
        </div>
      </div>
      {rows.map((row: colorRow) => {
        return (
          <ColorRowWrapper>
            <ColorOverlay color={row.hex}>
              {color !== 'White' && (
                <CustomHoverText color={row.text} style={{ minWidth: 66 }} onClick={() => handleClick(row.hex.toLowerCase())}>
                  {row.hex.toLowerCase()}
                </CustomHoverText>
              )}
              <CustomHoverText color={row.text} style={{ minWidth: 90 }} onClick={() => handleClick(row.name)}>
                {row.name}
              </CustomHoverText>
              <CustomHoverText
                color={row.text}
                style={{ minWidth: color === 'White' ? 156 : 120 }}
                onClick={() => handleClick(row.rgb ? row.rgb : row.hex)}
              >
                {row.rgb ? row.rgb : row.hex}
              </CustomHoverText>
            </ColorOverlay>
          </ColorRowWrapper>
        );
      })}
      <textarea style={{ position: 'fixed', top: 0, opacity: 0 }} ref={textArea} readOnly />
      <SnackBar {...snackBarObject} />
    </ColorSwatchWrapper>
  );
};
